import Joi from "joi";

export const lineitem_schema = Joi.object({
  lot: Joi.string().min(1).required(),
  description: Joi.string().min(1).required(),
  qty: Joi.number().integer().min(1).required(),
  price: Joi.string().regex(/[\d.]/).required(),
});
